import React, { useState, useEffect } from 'react';
import AdminAdvertisementList from '../components/advertisement/AdminAdvertisementList'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';

export default function AdminAdvertisement() {
  const userUID = useSelector(state => state.user.uid);
  const [garage, setGarage] = useState()
  const [showDiv, setShowDiv] = useState(false);
  useEffect(() => {
    if (userUID !== 'none') {
      axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetAdbyadmin', ownerID: 'admin' })
        .then(response => {
          setGarage(response.data.data);
          console.log("response", response.data)
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }

    const timer = setTimeout(() => {
      setShowDiv(true);
    }, 1200);
  }, [userUID]);

  return (
    <section className="page-content sec-padding">
      <div className="container-fluid">
        <div className="page-content-details">
          <div className="sec-title row">
            <div className="col-md-6 text-start">
              <h3>Advertisement</h3>
            </div>
          </div>
          <div className='row'>
            {garage ? <AdminAdvertisementList garagesList={garage} actions={{ delete: true, edit: true, comingsoon: true }} /> :
              showDiv && <div className='typewriter '>No Advertisement yet</div>}
          </div>
        </div>
      </div>
    </section>
  );
}